module.exports = __webpack_public_path__ + "static/media/help_cleaning.b49540b1.jpg";